import useTimeZoneClock from 'hooks/useTimeZoneClock';
import { getBackgroundStyle } from 'components/common/TableColor';
import moment from 'moment';
import React from 'react'
import { SubmitButton } from './common/buttons/SubmitButton';

const AppointmentDetailsTable = ({ item }) => {
  const timeZone = useTimeZoneClock(item?.datetime);
    const formattedDate = moment(timeZone).format('MMMM DD YYYY');
    const formattedTime = moment(timeZone).format('hh:mm A');
    
    const InfoRow = ({ label, value, toLowerCase = "" }) => (
        <div className='row_detail_tab'>
            <div className='label_view'><strong>{label}</strong></div>
            <div className={`detail_view ${toLowerCase}`}>{value || 'N/A'}</div>
        </div>
    );
    const rowDash1Style = {
        display: 'flex',
        alignItems: 'normal',
        width: '100%',
        gap: '1rem'
    };
    const rowDash2Style = {
        display: 'block',
        alignItems: 'normal',
        width: '100%',
        gap: '1rem'
    };
    const marginTopZero = {
        marginTop: 0
    };

    console.log("item", item)
  return (
     <div className="Table_data_show Table_data_show1 p-0 overflow-auto">
               <div className="row_dash_1" style={rowDash1Style}>
                   <div className="card_table" style={marginTopZero}>
                     
                       <div className="Table_data_show Table_data_show1 pt-0">
                       <table class="bg-primary-secondary table">
                           <tbody>
                               <tr>
                                   <td class="bg-primary-secondary" style={{ width: "40%" }}>Facility: </td>
                                   <td class="bg-primary-secondary">{item?.appointment_details?.facility?.abbreviation}</td>
                               </tr>
                               <tr>
                                   <td class="bg-primary-secondary" style={{ width: "40%" }}>Department: </td>
                                   <td class="bg-primary-secondary">{item?.appointment_details?.department?.department_name}</td>
                               </tr>
                               <tr>
                                   <td class="bg-primary-secondary" style={{ width: "40%" }}>Address:</td>
                                   <td class="bg-primary-secondary">{item.appointment_details?.facility?.address}</td>
                               </tr>
                           </tbody>
                       </table>
                       </div>
                       <div className="interpreter p-4">
                           <h2>Interpreter / Vendor:</h2>
                       </div>
                       <div className="Table_data_show Table_data_show1 pt-0">
                           <table class="bg-primary-secondary table">
                               <tbody>
                                   <tr>
                                       <td class="bg-primary-secondary" style={{ width: "40%" }}>Interpreter Name: </td>
                                       <td className="bg-primary-secondary">
                                           {item?.interpreter?.vendor
                                           ? item?.interpreter?.user?.name + ' - ' + item?.interpreter?.vendor?.name
                                           : item?.interpreter?.user?.name  || 'N/A'}
                                       </td>
                                   </tr>
                                   <tr>
                                       <td class="bg-primary-secondary" style={{ width: "40%" }}>Interpreter Email: </td>
                                       <td class="bg-primary-secondary">{item?.interpreter?.user?.email  || 'N/A'}</td>
                                   </tr>
                                   <tr>
                                       <td class="bg-primary-secondary" style={{ width: "40%" }}>Interpreter Phone: </td>
                                       <td class="bg-primary-secondary">{item?.interpreter?.phone  || 'N/A'}</td>
                                   </tr>
                               </tbody>
                           </table>
                       </div>
                       <div className="Table_data_show Table_data_show2 pt-0">
                           <table class="bg-primary-secondary table">
                               <tbody>
                                   <tr>
                                       <td class="bg-primary-secondary" style={{ width: "40%" }}>Provider Name: </td>
                                       <td class="bg-primary-secondary">{item.appointment_details?.provider_name || 'N/A'}</td>
                                   </tr>
                               </tbody>
                           </table>
                       </div>
                       
                   </div>
                   
                   <div className="card_table" style={marginTopZero}>
                           
                       <div className="Table_data_show Table_data_show1 pt-0 ">
                           <table class="bg-info-secondary table" style={getBackgroundStyle(item?.status)}>
                               <tbody>
                                   <tr>
                                   <td className="bg-info-secondary" style={{ ...getBackgroundStyle(item?.status), width: "40%" }}>Status: </td>
                                       <td className="bg-info-secondary capitalize-status" style={getBackgroundStyle(item?.status)}>{item?.status}</td>
                                   </tr>
                               </tbody>
                           </table>
                       </div>
                       <div className="Table_data_show Table_data_show1 pt-0 ">
                           <table class="bg-primary-secondary table">
                               <tbody>
                                   <tr>
                                       <td class="bg-primary-secondary" style={{ width: "40%" }}>Patient Name: </td>
                                       <td class="bg-primary-secondary">{item.appointment_details?.patient?.patient_name  || 'N/A'}</td>
                                   </tr>
                                   <tr>
                                       <td class="bg-primary-secondary" style={{ width: "40%" }}>MRN:</td>
                                       <td class="bg-primary-secondary">{item.appointment_details?.patient?.mrn_number  || 'N/A'}</td>
                                   </tr>
                                   <tr>
                                       <td class="bg-primary-secondary" style={{ width: "40%" }}>DOB:</td>
                                       <td class="bg-primary-secondary">{item.appointment_details?.patient?.birth_date  || 'N/A'}</td>
                                   </tr>
                                   <tr>
                                       <td class="bg-primary-secondary" style={{ width: "40%" }}>Medicaid ID:</td>
                                       <td class="bg-primary-secondary">{item.appointment_details?.patient?.medicaid_id  || 'N/A'}</td>
                                   </tr>
                                   <tr>
                                       <td class="bg-primary-secondary" style={{ width: "40%" }}>Health Plan:</td>
                                       <td class="bg-primary-secondary">{item.appointment_details?.patient?.medicaid_plan  || 'N/A'}</td>
                                   </tr>
                               </tbody>
                           </table>
                       </div>
                       <div className="Table_data_show Table_data_show1 pt-0 ">
                           <table class="bg-primary-secondary table">
                               <tbody>
                                   <tr>
                                       <td class="bg-primary-secondary" style={{ width: "40%" }}>Requester Name: </td>
                                       <td class="bg-primary-secondary">{item.appointment_details?.requester_name || 'N/A'}</td>
                                   </tr>
                                   <tr>
                                       <td class="bg-primary-secondary" style={{ width: "40%" }}>Requester Email: </td>
                                       <td class="bg-primary-secondary" toLowerCase={'text-lowercase'}>{item.appointment_details?.requester_email || 'N/A'}</td>
                                   </tr>
                                   <tr>
                                       <td class="bg-primary-secondary" style={{ width: "40%" }}>Requester Phone:</td>
                                       <td class="bg-primary-secondary">{item.appointment_details?.requester_phone || 'N/A'}</td>
                                   </tr>
                               </tbody>
                           </table>
                       </div>
                   </div>
               </div>
               <div className="row_dash_1" style={rowDash2Style}>
                   <div className="Table_data_show Table_data_show1 pt-0 ">
                           <table class="bg-primary-secondary table">
                           <tbody>
                                   <tr>
                                       <td class="bg-primary-secondary" style={{ width: "20%" }}>Estimated Duration: </td>
                                       <td class="bg-primary-secondary" >{`${item.duration} minutes`}</td>
                                   
                                       <td class="bg-primary-secondary">Rescheduled Reason: </td>
                                       <td class="bg-primary-secondary">{item?.appointment_details?.reschedule_reason || 'N/A'}</td>
                                  
                                       <td class="bg-primary-secondary">Priority Level:</td>
                                       <td class="bg-primary-secondary">{item.appointment_details?.priority_level}</td>
                                   </tr>
                                   <tr>
                                       <td class="bg-primary-secondary">Encounter Source: </td>
                                       <td class="bg-primary-secondary">{item.appointment_details?.encounter_source  || 'N/A'}</td>
                                   
                                       <td class="bg-primary-secondary">Cancel reason: </td>
                                       <td class="bg-primary-secondary">{item?.appointment_details?.cancel_reason || 'N/A'}</td>
                                  
                                       {/* <td class="bg-primary-secondary">Notes:</td>
                                       <td class="bg-primary-secondary">{item.appointment_assign?.notes  || 'N/A'}</td> */}
                                        <td class="bg-primary-secondary">Special Instructions:</td>
                                       <td class="bg-primary-secondary">{item.appointment_details?.special_instruction}</td>
                                   </tr>
                                   <tr>
                                      
                                       <td class="bg-primary-secondary">DNC Reason:</td>
                                       <td class="bg-primary-secondary">{item?.appointment_details?.dnc_reason || 'N/A'}</td>  
                                       <td class="bg-primary-secondary">CNC Reason:</td>
                                       <td class="bg-primary-secondary">{item?.appointment_details?.cnc_reason || 'N/A'}</td>
                                   </tr>
                                   {/* <tr> */}
                                       {/* <td class="bg-primary-secondary">Checkin Date:</td>
                                       <td class="bg-primary-secondary" colSpan={2}>{item.appointment_assign?.checkin_date || 'N/A'}</td> */}
                                       {/* <td class="bg-primary-secondary">Checkin Time:</td>
                                       <td class="bg-primary-secondary" colSpan={2}>{item.appointment_assign?.checkin_time || 'N/A'}</td>   */}
                                   {/* </tr> */}
                                   {/* <tr>
                                       <td class="bg-primary-secondary">Checkout Date:</td>
                                       <td class="bg-primary-secondary" colSpan={2}>{item.appointment_assign?.checkout_date || 'N/A'}</td>
                                       <td class="bg-primary-secondary">Checkout Time:</td>
                                       <td class="bg-primary-secondary" colSpan={2}>{item.appointment_assign?.checkout_time || 'N/A'}</td>
                                   </tr> */}
                                   {/* <tr>
                                       <td class="bg-primary-secondary">Comments:</td>
                                       <td class="bg-primary-secondary" colSpan={6}>{item.appointment_assign?.comments || 'N/A'}</td>
                                   </tr> */}
                               </tbody>
                           </table>
                   </div>
               </div>
              
           </div>
  );
};

export default AppointmentDetailsTable;





